/* eslint-disable new-cap */
import { get } from 'lodash';

import createReducer from 'Store/utils/createReducer';
import { SEARCH_SET_KEYWORDS } from 'Store/constants';

const initialState = {
  keywords: '',
};

export const searchQueryReducer = createReducer(initialState, {
  [SEARCH_SET_KEYWORDS](state, action) {
    return {
      ...state,
      keywords: get(action, 'payload.keywords'),
    };
  },
});
